import type { CollectedIntegrationConfig } from '@cli-types/next-adapter/runtime.js'
import { resolvePasswordEnvValue } from './resolve-password-env-value.js'
import { resolveTextEnvValue } from './resolve-text-env-value.js'

export async function collectR2Config(cwd: string): Promise<CollectedIntegrationConfig> {
  const overwriteEnvKeys = new Set<string>()
  const accountId = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_R2_ACCOUNT_ID',
    message: 'Cloudflare account ID',
    cancelMessage: 'R2 configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) return 'Enter your Cloudflare account ID.'
    }
  })
  const accessKeyId = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_R2_ACCESS_KEY_ID',
    message: 'Cloudflare R2 access key ID',
    cancelMessage: 'R2 configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) return 'Enter your R2 access key ID.'
    }
  })
  const secretAccessKey = await resolvePasswordEnvValue({
    cwd,
    key: 'BETTERSTART_R2_SECRET_ACCESS_KEY',
    message: 'Cloudflare R2 secret access key',
    cancelMessage: 'R2 configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) return 'Enter your R2 secret access key.'
    }
  })
  const bucketName = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_R2_BUCKET_NAME',
    message: 'Cloudflare R2 bucket name',
    defaultValue: 'betterstart-uploads',
    cancelMessage: 'R2 configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) return 'Enter your R2 bucket name.'
    }
  })
  const publicUrl = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_R2_PUBLIC_URL',
    message: 'Cloudflare R2 public URL',
    cancelMessage: 'R2 configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim() || !value.startsWith('http')) {
        return 'Enter a valid public URL.'
      }
    }
  })

  return {
    sections: [
      {
        header: 'Storage (Cloudflare R2)',
        vars: [
          { key: 'BETTERSTART_R2_ACCOUNT_ID', value: accountId.trim() },
          { key: 'BETTERSTART_R2_ACCESS_KEY_ID', value: accessKeyId.trim() },
          { key: 'BETTERSTART_R2_SECRET_ACCESS_KEY', value: secretAccessKey.trim() },
          { key: 'BETTERSTART_R2_BUCKET_NAME', value: bucketName.trim() },
          { key: 'BETTERSTART_R2_PUBLIC_URL', value: publicUrl.trim() }
        ]
      }
    ],
    overwriteKeys: overwriteEnvKeys
  }
}
